// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Invoice from "./invoice.js"
import Product from "./product.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "product_id": {
      "column": {
        "default": null,
        "name": "product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "product_id",
      "selected_by_default": null,
      "translated": null
    },
    "text": {
      "column": {
        "default": null,
        "name": "text",
        "null": false,
        "type": "text"
      },
      "name": "text",
      "selected_by_default": null,
      "translated": null
    },
    "unit_price": {
      "column": null,
      "name": "unit_price",
      "selected_by_default": null,
      "translated": null
    },
    "quantity": {
      "column": {
        "default": null,
        "name": "quantity",
        "null": false,
        "type": "float"
      },
      "name": "quantity",
      "selected_by_default": null,
      "translated": null
    },
    "tax": {
      "column": null,
      "name": "tax",
      "selected_by_default": null,
      "translated": null
    },
    "total": {
      "column": null,
      "name": "total",
      "selected_by_default": null,
      "translated": null
    },
    "resource": {
      "column": null,
      "name": "resource",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "InvoiceLine",
  "collectionKey": "invoice_lines",
  "collectionName": "invoice_lines",
  "i18nKey": "invoice_line",
  "camelizedLower": "invoiceLine",
  "name": "InvoiceLine",
  "nameDasherized": "invoice-line",
  "pluralName": "invoice_lines",
  "ransackable_associations": [
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "credit_note_for_id",
      "name": "credit_note",
      "macro": "has_one",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "credit_note_for_id",
      "name": "credit_note_for",
      "macro": "belongs_to",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "invoice_id",
      "name": "invoice",
      "macro": "belongs_to",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "product_id",
      "name": "product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SubscriptionPeriod",
      "collectionName": "subscription_periods",
      "foreignKey": "invoice_line_id",
      "name": "subscription_period",
      "macro": "has_one",
      "resource_name": "SubscriptionPeriod",
      "through": null
    },
    {
      "className": "SubscriptionRenewalGeneration",
      "collectionName": "subscription_renewal_generations",
      "foreignKey": "subscription_renewal_generation_id",
      "name": "subscription_renewal_generation",
      "macro": "has_one",
      "resource_name": "SubscriptionRenewalGeneration",
      "through": "subscription_period"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "credit_note_for_id",
      "column": {
        "default": null,
        "name": "credit_note_for_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "invoice_id",
      "column": {
        "default": null,
        "name": "invoice_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "old_credit_note_for_id",
      "column": {
        "default": null,
        "name": "old_credit_note_for_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_invoice_id",
      "column": {
        "default": null,
        "name": "old_invoice_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_product_id",
      "column": {
        "default": null,
        "name": "old_product_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_resource_id",
      "column": {
        "default": null,
        "name": "old_resource_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "product_id",
      "column": {
        "default": null,
        "name": "product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "quantity",
      "column": {
        "default": null,
        "name": "quantity",
        "null": false,
        "type": "float"
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "sales_line_number",
      "column": {
        "default": null,
        "name": "sales_line_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tax_cents",
      "column": {
        "default": 0,
        "name": "tax_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tax_currency",
      "column": {
        "default": "DKK",
        "name": "tax_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text",
      "column": {
        "default": null,
        "name": "text",
        "null": false,
        "type": "text"
      }
    },
    {
      "name": "total_cents",
      "column": {
        "default": 0,
        "name": "total_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "total_currency",
      "column": {
        "default": "DKK",
        "name": "total_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "unit_price_cents",
      "column": {
        "default": 0,
        "name": "unit_price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "unit_price_currency",
      "column": {
        "default": "DKK",
        "name": "unit_price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "invoice_id",
      "name": "invoice",
      "macro": "belongs_to",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "product_id",
      "name": "product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    }
  ],
  "paramKey": "invoice_line",
  "primaryKey": "id"
}

/** Frontend model for InvoiceLine. */
export default class InvoiceLine extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  productId() {
    return this.readAttributeUnderscore("product_id")
  }

  /** @returns {boolean} */
  hasProductId() {
    const value = this.productId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  text() {
    return this.readAttributeUnderscore("text")
  }

  /** @returns {boolean} */
  hasText() {
    const value = this.text()

    return this._isPresent(value)
  }

  /** @returns {any} */
  unitPrice() {
    return this.readAttributeUnderscore("unit_price")
  }

  /** @returns {boolean} */
  hasUnitPrice() {
    const value = this.unitPrice()

    return this._isPresent(value)
  }

  /** @returns {number} */
  quantity() {
    return this.readAttributeUnderscore("quantity")
  }

  /** @returns {boolean} */
  hasQuantity() {
    const value = this.quantity()

    return this._isPresent(value)
  }

  /** @returns {any} */
  tax() {
    return this.readAttributeUnderscore("tax")
  }

  /** @returns {boolean} */
  hasTax() {
    const value = this.tax()

    return this._isPresent(value)
  }

  /** @returns {any} */
  total() {
    return this.readAttributeUnderscore("total")
  }

  /** @returns {boolean} */
  hasTotal() {
    const value = this.total()

    return this._isPresent(value)
  }

  /** @returns {any} */
  resource() {
    return this.readAttributeUnderscore("resource")
  }

  /** @returns {boolean} */
  hasResource() {
    const value = this.resource()

    return this._isPresent(value)
  }

  /** @returns {import("./invoice.js").default | null} */
  invoice() {
    return this._readBelongsToReflection({modelClass: Invoice, reflectionName: "invoice"})
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  loadInvoice() {
    if (!("invoiceId" in this)) throw new Error("Foreign key method wasn't defined: invoiceId")

    const id = this.invoiceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "invoice",
        model: this,
        modelClass: Invoice
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  ensureInvoiceLoaded() {
    return this.ensureAssociationLoaded("invoice")
  }

  /** @returns {import("./product.js").default | null} */
  product() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadProduct() {
    if (!("productId" in this)) throw new Error("Foreign key method wasn't defined: productId")

    const id = this.productId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureProductLoaded() {
    return this.ensureAssociationLoaded("product")
  }
}
